export const GRID = 'grid';
export const FAMILY = 'family';
export const SEARCH = 'search';
